<template>
  <div id="menu" class="menu-container">
    <div class="menu-main">
      <el-menu :default-active="activeId" class="el-menu-vertical">
        <template v-for="menu in menuData">
          <template v-if="canShowMenu(menu.hideSoftware)">
            <el-submenu v-if="menu.children && menu.children.length" :key="menu.id" :index="menu.id">
              <template slot="title">
                <i class="icon-i iconfont" :class="menu.icon" />
                <span class="title">{{menu.title}}</span>
              </template>
              <template v-for="subMenu in menu.children">
                <el-menu-item
                    v-if="canShowMenu(subMenu.showSoftware)"
                    :key="subMenu.id"
                    :index="subMenu.id"
                    @click="goPage(subMenu.id)"
                >{{subMenu.title}}</el-menu-item>
              </template>
            </el-submenu>
            <el-menu-item
                v-else
                :index="menu.id"
                :key="menu.id"
                @click="goPage(menu.id)"
            >
              <i class="icon-i iconfont" :class="menu.icon" />
              <span slot="title" class="title">{{ menu.title }}</span>
            </el-menu-item>
          </template>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Menu from '@/assets/js/menu'
export default {
  data() {
    return {
      activeId: 'ComponentList',
      menuData: Menu.menus,
    }
  },
  computed: {
    ...mapGetters({
      platform: 'platform',
      softwareCode: 'softwareCode',
    }),
  },
  watch: {
    '$route.name': {
      handler() {
        if (['FederationPlanList', 'IntegratedModelList'].includes(this.$route.name)) {
          this.activeId = 'File'
          return
        }
        this.activeId = `${this.$route.name}`
      },
      immediate: true
    },
  },
  methods: {
    goPage(name) {
      this.$router.push({ name: name })
    },
    canShowMenu(showSoftware) {
      return this.platform === 'web' || !showSoftware || showSoftware.includes(this.softwareCode)
    },
  },
}
</script>

<style lang="less" scoped>
.menu-container {
  font-size: 14px;
  background-color: #f7f9fa;
  height: calc(100vh - 40px);
}

.menu-main {
  position: relative;
  overflow: hidden;
  width: 100%;
  background-color: #f7f9fa;
  border-right: 1px solid @border-color-tag;
  transition: width 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);
  height: calc(100vh - 40px);
  .icon-i {
    position: relative;
    top: -1px;
  }
  .title {
    margin-left: 6px;
  }
}

.divide-line {
  height: 1px;
  background: #e6e6e6;
  margin-top: 8px;
}

img {
  height: 18px;
  width: 18px;
}

/deep/.el-menu {
  border: none;
  height: 100%;
  width: 100px;
}
/deep/ .el-submenu .el-menu-item{
  padding: 0 0 0 34px !important;
  min-width: unset;
}

/deep/ .el-submenu__title {
  padding: 0 2px;
  i{
    color: unset;
  }
}
/deep/ .el-submenu__icon-arrow{
  right: 2px;
  margin-top: -6px;
}
/deep/ .el-menu-item i{
  color: unset;
}

/deep/ .el-submenu__title .el-icon-arrow-down{
  right: 4px;
}

.el-menu-item {
  min-width: 0;
  padding: 0 2px;
}

.menu-collapse {
  cursor: pointer;
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 8px;
  i {
    width: 24px;
    height: 24px;
    text-align: center;
    line-height: 24px;
  }
  :hover {
    background-color: #dae0e8;
    border-radius: 4px;
  }
}
</style>
